import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';

// material-ui
import { Box, Button, Grid, Tab, Tabs, CardMedia } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import ScoreboardRoundedIcon from '@mui/icons-material/ScoreboardRounded';
import StorefrontIcon from '@mui/icons-material/Storefront';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import LibraryBooksTwoToneIcon from '@mui/icons-material/LibraryBooksTwoTone';
import ContactsIcon from '@mui/icons-material/Contacts';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';

// project imports
import VenueDetails from './VenueDetails';
import Transaction from './Transaction';
import TurfDetails from './TurfDetails';
import BoardDetails from './Board/BoardDetails';
import MainCard from 'ui-component/cards/MainCard';
import { gridSpacing } from 'store/constant';
import useApi from 'hooks/useApi';
import VenueService from 'services/VenueService';
import UserList from '../ViewVenue/UserDetails'
import PriceList from './PriceDetails';
import Bookings from './Bookings';
import MasterService from 'services/MasterService';

// tabs panel
function TabPanel({ children, value, index, ...other }) {
    return (
        <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
            {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
        </div>
    );
}
TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired
};
function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`
    };
}

// tabs option
const tabsOption = [
    { label: 'Venue Details', icon: <StorefrontIcon sx={{ fontSize: '1.3rem' }} /> },
    { label: 'Court', icon: <LibraryBooksTwoToneIcon sx={{ fontSize: '1.3rem' }} /> },
    { label: 'Price Details', icon: <CurrencyRupeeIcon sx={{ fontSize: '1.3rem' }} /> },
    { label: 'Board', icon: <ScoreboardRoundedIcon sx={{ fontSize: '1.3rem' }} /> },
    { label: 'Manager', icon: <ContactsIcon sx={{ fontSize: '1.3rem' }} /> },
    { label: 'Bookings', icon: <ContactsIcon sx={{ fontSize: '1.3rem' }} /> },
    { label: 'Transaction', icon: <ReceiptLongIcon sx={{ fontSize: '1.3rem' }} /> }
];

const ViewVenue = () => {

    const theme = useTheme();
    const navigate = useNavigate();
    const { venueUuid } = useParams();
    const [venueObj, setVenueObj] = useState({});
    const [value, setValue] = useState(0);
    const [sportsTypes, setSportsType] = useState([])

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const getVenueHandler = (response) => {
        setVenueObj(response.data);
    };

    const handleOnClick = () => {
        navigate('/venue')
    };

    const getStHandler = (response) => {
        const data = response.data;
        setSportsType(data);
        getVenueApi.execute(venueUuid);
    }

    const getVenueApi = useApi(VenueService.getVenueByUuid, getVenueHandler);
    const getSportsTypeListApi = useApi(MasterService.getDropdownSportsType, getStHandler)

    useEffect(() => {
        getSportsTypeListApi.execute();
    }, []);

    return (
        <MainCard>
            <Grid container spacing={gridSpacing}>
                <Grid xs={12} sx={{ display: 'flex', justifyContent: 'end', marginTop: 2.5 }}>
                    <Button
                        size='small'
                        variant="contained"
                        color="secondary"
                        onClick={() => handleOnClick()}
                    >
                        Back
                    </Button>
                </Grid>
                <Grid item sm={12}>
                    <Grid container
                        component={venueObj.banner_image ? "text" : "label"}
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            backgroundColor: '#f0f0f0',
                            position: 'relative',
                            overflow: 'hidden',
                            height: '250px',
                            borderRadius: '8px',
                            cursor: venueObj.banner_image ? '' : 'pointer'
                        }}
                    >
                        <CardMedia
                            component="img"
                            alt="Banner Image"
                            image={venueObj.banner_image}
                            sx={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'fill',
                                borderRadius: '8px',
                            }}
                        />
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Tabs
                        value={value}
                        indicatorColor="primary"
                        textColor="primary"
                        onChange={handleChange}
                        aria-label="simple tabs example"
                        variant="scrollable"
                        sx={{
                            mb: 3,
                            '& a': {
                                minHeight: 'auto',
                                minWidth: 10,
                                py: 1.5,
                                px: 1,
                                mr: 2.25,
                                color: theme.palette.mode === 'dark' ? 'grey.600' : 'grey.550',
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                justifyContent: 'center'
                            },
                            '& a.Mui-selected': {
                                color: theme.palette.primary.main
                            },
                            '& .MuiTabs-indicator': {
                                bottom: 2
                            },
                            '& a > svg': {
                                marginBottom: '0px !important',
                                mr: 1.25
                            }
                        }}
                    >
                        {tabsOption.map((tab, index) => (
                            <Tab key={index} component={Link} to="#" icon={tab.icon} label={tab.label} {...a11yProps(index)} />
                        ))}
                    </Tabs>
                    <TabPanel value={value} index={0}>
                        <VenueDetails venueUuid={venueUuid} venueObj={venueObj}
                            sportsTypes={sportsTypes} />
                    </TabPanel>
                    <TabPanel value={value} index={1}>
                        <TurfDetails venueUuid={venueUuid}
                            sportsTypes={sportsTypes} />
                    </TabPanel>
                    <TabPanel value={value} index={2}>
                        <PriceList venueUuid={venueUuid}
                            sportsTypes={sportsTypes} />
                    </TabPanel>
                    <TabPanel value={value} index={3}>
                        <BoardDetails venueUuid={venueUuid} />
                    </TabPanel>
                    <TabPanel value={value} index={4}>
                        <UserList venueUuid={venueUuid} />
                    </TabPanel>
                    <TabPanel value={value} index={5}>
                        <Bookings venueUuid={venueUuid} />
                    </TabPanel>
                    <TabPanel value={value} index={6}>
                        <Transaction venueUuid={venueUuid} />
                    </TabPanel>
                </Grid>
            </Grid>
        </MainCard>
    );
};

export default ViewVenue;
